import { Contact } from '../components/Contact'

const ContactPage = () => {
  return (
    <div
      className="
        relative bg-white dark:bg-gray-900 transition-colors duration-300
        min-h-[calc(100vh-8.5rem)]   /* fills viewport minus navbar height */
        flex flex-col
      "
    >
      <Contact />
    </div>
  )
}

export default ContactPage;
